module.exports = __webpack_public_path__ + "img/rooms2221.e11be51d.png";